import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './login/auth.service';
import { User } from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkAccess();
  }

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkAccess();
  }

  private checkAccess(): Observable<boolean | UrlTree> {
    if (!this.authService.hasAuthCookies()) {
      return of(this.router.parseUrl('/login'));
    }

    return this.authService.syncCurrentUser().pipe(
      map((user) => (this.isAdmin(user) ? true : this.router.parseUrl('/'))),
      catchError(() => of(this.router.parseUrl('/')))
    );
  }

  private isAdmin(user: User) {
    return user.roles?.some((role) => role.description === 'admin') === true;
  }
}
